<template>
  <div>
    <a-select
      show-search
      :value="value"
      :placeholder="$t(placeholder)"
      style="width: 300px"
      :default-active-first-option="false"
      :show-arrow="false"
      :filter-option="false"
      :not-found-content="null"
      :mode="mode"
      @search="handleSearch"
      @change="handleChange"
    >
      <a-select-option
        v-for="d in data"
        :key="d.value"
      >
        {{ d.text }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
import sellerService from '@/services/api/admin/stores/seller-service'

export default {
  name: 'SellerSearch',
  props: {
    mode: {
      type: String,
      default () {
        return 'multiple'
      },
    },
    returnIntId: {
      type: Boolean,
      default () {
        return true
      },
    },
    searchField: {
      type: String,
      default () {
        return 'title'
      },
    },
    placeholder: {
      type: String,
      default: 'seller.general.title',
    },
  },
  data() {
    return {
      data: [],
      value: undefined,
      queryParam: '',
      timeout: null,
    }
  },
  methods: {
    handleSearch(value) {
      if ((value?.length ?? 0) < 3)
        return

      this.queryParam = value
      window.setTimeout(this.fetchCompanies, 500, value)
    },
    handleChange(value) {
      this.value = value
      this.$emit('input', value)
    },
    fetchCompanies (queryParam) {
      if (queryParam.length === this.queryParam.length && queryParam.length > 2) {
        const pagination = {
          current: 1,
          pageSize: 15,
        }

        const filter = {}
        filter[this.searchField] = queryParam

        sellerService.sellerCompanies(pagination, null, filter)
          .then((response) => {
            const companies = response?.data?.content ?? []
            this.data = companies.map((cmp) => {
              return {
                value: this.returnIntId ? cmp?.id : cmp?.general_info?.id,
                text: this.$l(cmp?.general_info?.title),
              }
            })
          })
      }
    },
  },
}
</script>

<style scoped>

</style>
